<template>
   <v-container fluid grid-list-xl py-0>

           <v-layout row wrap>
                <v-btn color="success" @click="btnSaveRes" name="btnsave" class="text-xs-right" :disabled="disable">Opslaan</v-btn>
           </v-layout>
			<v-layout row wrap>
                 
                
				<app-card
					:heading="''"
					:fullBlock="true"
					colClasses="xl6">
					 <v-toolbar color="white" light>
                            <v-toolbar-title>Behandelingen online uitvoerbaar door {{this.record.UserName}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>

					<v-data-table
						v-bind:headers="headersTrans"
						v-bind:items="dataRecs"  :rows-per-page-items="[-1]">
						<template slot="items" slot-scope="props">
							<td>{{props.item.UserName}}</td>
                            <td><v-checkbox v-model="props.item.IsActive" @change="selChanged (props.item)"></v-checkbox></td>
						</template>
						
					</v-data-table>
				</app-card>
			</v-layout>
  	</v-container>


</template>

<script>

import myHttpApi from "../../api/myHttpApi";
import router from '../../router';
import moment from 'moment'

export default {
  props: {
      record : Object,
      onlineUsrData : Object
  },
   components: {
  },
  mounted() {
      //console.log  (moment(String('2000-01-01T09:00:13')).format('MM/DD/YYYY hh:mm'));
      //console.log (this.record);
      //this.getTableData ();
  },
  data() {
    return {
        currentRec : '',
        dialog4 : false,
        isChanged : false,
        disable: false,
        dataRecs : {},
		headersTrans: [
			{ text: "Omschrijving", value:""},
            { text: "Online gebruiken", value:""},
        ]
    }
  },
   methods: {
        getTableData() {
            myHttpApi
                myHttpApi.post('BOUser/GetOnlineServices', this.record)
                .then(response => {
                this.loader = false;

                this.dataRecs = response.data;
              
                })
                .catch(error => {
                console.log(error);
                });
            },
        selChanged (rec) {
           
            console.log ("check changed");
            this.isChanged = true;
            this.onlineUsrData = this.dataRecs;
        },
        btnSaveRes () {
            myHttpApi
             myHttpApi.post('BOUser/SaveOnlineServices', this.onlineUsrData)
                    .then(response => {
                        this.disable = true;
                    })
                    .catch(error => {
                        console.log(error);
                        alert (error);
                    });
        }
  },
   watch: {
	record(newId, oldId) {
       console.log (newId);
       this.getTableData();
    }
  }
};
</script>
